/**
 * AI Bestseller Carousel Fix
 * ---------------------------
 * Repariert die Pfeil-Navigation der via Sidekick generierten Bestseller-Section
 * (Section-ID dynamisch, daher Class- und ARIA-Selector statt fester ID).
 *
 * Problem: Sidekick-AI-Blocks generieren Pfeile mit Klassen .ai-bestseller-nav-pr/.ai-bestseller-nav-ne
 * aber ohne Event-Listener. Buttons sind klickbar, lösen aber kein Scroll aus.
 *
 * Fix: Vanilla-JS, Event-Delegation, scrollt den Carousel-Container um eine Item-Breite.
 * Funktioniert auch wenn Sidekick die Section regeneriert (Klassen bleiben stabil).
 *
 * Erstellt: 2026-04-29 (CEO-Feedback Phase 2 Bug-Fix)
 * Eingebunden in: layout/theme.liquid (vor </body>)
 */
(function () {
  'use strict';

  function initBestsellerCarousels() {
    // Alle Bestseller-Carousel-Container finden (Class enthält ai-bestseller-carousel ohne wrapper)
    const carousels = document.querySelectorAll(
      '[class*="ai-bestseller-carousel"]:not([class*="wrapper"])'
    );

    carousels.forEach(function (carousel) {
      // Mehrfach-Init-Schutz
      if (carousel.dataset.fixApplied === '1') return;
      carousel.dataset.fixApplied = '1';

      // Wrapper finden (Eltern-Container der Pfeile + Carousel enthaelt)
      const wrapper = carousel.closest('[class*="ai-bestseller-carousel-wrapper"]');
      if (!wrapper) return;

      // Pfeile via aria-label finden (sprachunabhaengig robust durch Selector-Kombination)
      const prevBtn =
        wrapper.parentElement.querySelector('[aria-label="Vorheriges Produkt"]') ||
        wrapper.parentElement.querySelector('[class*="ai-bestseller-nav-pr"]') ||
        wrapper.parentElement.querySelector('[aria-label*="Previous"]');
      const nextBtn =
        wrapper.parentElement.querySelector('[aria-label="Naechstes Produkt"]') ||
        wrapper.parentElement.querySelector('[aria-label="Nächstes Produkt"]') ||
        wrapper.parentElement.querySelector('[class*="ai-bestseller-nav-ne"]') ||
        wrapper.parentElement.querySelector('[aria-label*="Next"]');

      if (!prevBtn || !nextBtn) return;

      function scrollAmount() {
        const firstItem = carousel.children[0];
        if (!firstItem) return 320;
        const itemWidth = firstItem.getBoundingClientRect().width;
        // Gap aus Computed Style mitnehmen falls vorhanden
        const cs = window.getComputedStyle(carousel);
        const gap = parseInt(cs.gap || cs.columnGap || '20', 10) || 20;
        return itemWidth + gap;
      }

      prevBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      // Optionaler Bonus: Pfeile disablen wenn Anfang/Ende erreicht
      function updateButtonStates() {
        const atStart = carousel.scrollLeft <= 1;
        const atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 1;
        prevBtn.style.opacity = atStart ? '0.4' : '1';
        prevBtn.style.cursor = atStart ? 'not-allowed' : 'pointer';
        nextBtn.style.opacity = atEnd ? '0.4' : '1';
        nextBtn.style.cursor = atEnd ? 'not-allowed' : 'pointer';
      }

      carousel.addEventListener('scroll', updateButtonStates, { passive: true });
      updateButtonStates();
    });
  }

  // Init bei DOMContentLoaded und bei Section-Reload (Theme-Editor-Live-Update)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestsellerCarousels);
  } else {
    initBestsellerCarousels();
  }

  // Shopify Theme-Editor: Section-Reload-Event abfangen
  document.addEventListener('shopify:section:load', initBestsellerCarousels);
})();
